/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react';
import { IAllModuleProps, IModalData, IModalProps } from '../interfaces/interfaces';

const ModalContext = React.createContext({
  modals: [],
  openModal: (modal: IModalProps) => {
    /**/
  },
  closeModal: (modal: IModalProps) => {
    /**/
  },
});

export function useModals(): [IModalData, (modal: IModalProps) => void, (modal: IModalProps) => void] {
  const initModalsData: IModalData = {
    modals: [],
    // eslint-disable-next-line no-console
    openModal: (modal: IModalProps) => {
      /**/
    },
    closeModal: (modal: IModalProps) => {
      /**/
    },
  };

  const [modalData, setModalData] = useState(initModalsData);

  const closeModal = (modal: IModalProps) => {
    const newModalData = { ...modalData };
    const index = newModalData.modals.indexOf(modal);

    if (index !== -1) {
      newModalData.modals.splice(index, 1);
      setModalData(newModalData);
    }
  };

  const openModal = (modal: IModalProps) => {
    const newModal = { ...modal };
    const oldAbort = newModal.onAbort;
    newModal.onAbort = () => {
      closeModal(newModal);
      oldAbort();
    };

    const oldConfirm = newModal.onConfirm;
    newModal.onConfirm = (data?) => {
      closeModal(newModal);
      oldConfirm(data);
    };
    const newModalData = { ...modalData };
    newModalData.modals.push(newModal);
    setModalData(newModalData);
  };

  return [modalData, openModal, closeModal];
}

export const ModalContextProvider = ModalContext.Provider;
export const ModalContextConsumer = ModalContext.Consumer;
export default ModalContext;
